import * as ss from "styled-system";
import { ITheme } from "./theme";
import styled, { createGlobalStyle, css } from "styled-components";

// Helper to get a value from the theme
export const get = (theme: ITheme, key: string) => ss.get(theme, key);
export const system = ss.system;
export const compose = ss.compose;
export {
	styled,
	createGlobalStyle,
	css,
}

// Common
export interface ICommonProps extends Omit<ss.ColorProps, "color">, ss.SpaceProps, ss.DisplayProps, ss.OpacityProps, ss.FlexProps {
	float?: ss.ResponsiveValue<"left" | "right" | "none" | "inherit">;
	clear?: ss.ResponsiveValue<"left" | "right" | "none" | "both" | "inherit">;
	transform?: ss.ResponsiveValue<string>;
	transition?: ss.ResponsiveValue<string>;
	textColor?: ss.ResponsiveValue<string>;
	color?: string;
}
export const COMMON = ss.compose(ss.color, ss.space, ss.display, ss.opacity, ss.flex, ss.system({
	float: true,
	clear: true,
	transform: true,
	transition: true,
	textColor: {
		property: "color",
		scale: "colors",
	},
}));

// Border
export interface IBorderProps extends ss.BorderProps, ss.ShadowProps {}
export const BORDER = ss.compose(ss.border, ss.shadow);

// Layout
export interface ILayoutProps extends ss.LayoutProps {};
export const LAYOUT = ss.layout;

// Position
export interface IPositionProps extends Omit<ss.PositionProps, "zIndex"> {
	zIndex?: string | number;
};
export const POSITION = ss.position;

// Flex
export interface IFlexProps extends ss.FlexboxProps {};
export const FLEX = ss.flexbox;

// Grid
export interface IGridProps extends ss.GridProps {};
export const GRID = ss.grid;

// Typography
export interface ITypographyProps extends ss.FontFamilyProps,
	ss.FontWeightProps, ss.LineHeightProps, ss.TextAlignProps, ss.FontStyleProps
{
	whiteSpace?: ss.ResponsiveValue<"normal"|"nowrap"|"pre-wrap"|"pre"|"pre-line">;
	textDecoration?: ss.ResponsiveValue<string>;
}
export const TYPOGRAPHY = ss.compose(ss.fontFamily, ss.fontWeight, ss.lineHeight,
	ss.textAlign, ss.fontStyle, ss.system({
	whiteSpace: true,
	textDecoration: true,
}));

// Font size
export interface IFontSizeProps extends ss.FontSizeProps {};
export const FONTSIZE = (props: ss.FontSizeProps & { theme?: ITheme }) => {
	let fontSize: any = props.fontSize;
	if (fontSize !== undefined &&
		typeof fontSize === "string" &&
		props.theme &&
		props.theme.fontNamedSizes &&
		props.theme.fontNamedSizes[fontSize]) {
		fontSize = props.theme.fontNamedSizes[fontSize];
	}
	return ss.fontSize({ ...props, fontSize });
};
FONTSIZE.propNames = ["fontSize"];
